<div class="not-implemented" [appStoryblok]="_editable()">
  <rds-empty-state>
    <img
      rds-empty-state-image
      src="../../../assets/work-in-progress.png"
      alt="Work in progress"
    />
    <rds-empty-state-title>
      The block "{{ component() }}" is not implemented...
    </rds-empty-state-title>
    <rds-empty-state-subtitle>
      But will be ready soon :)
    </rds-empty-state-subtitle>
  </rds-empty-state>
</div>
